export const PageText = {
  _1: 'The silent killer',
  _2: 'The effects of air pollution are alarming, mainly affecting the respiratory and cardiovascular system.'
};

export const Categories = {
  _1: {
    title: 'Health impact',
    subcategories: [
      {
        key: 0,
        subtitle: 'Deaths',
        text: 'Heart disease and stroke are the most common reasons for premature death, attributable to air pollution and are responsible for 80% of cases of premature death; lung diseases and lung cancer follow (WHO, 2014).'
      },
      {
        key: 1,
        subtitle: 'Diseases',
        text: 'In addition to causing premature death, air pollution increases the incidence of a wide range of diseases (e.g. respiratory and cardiovascular diseases and cancer), with both long and short-term health effects.'
      }
    ]
  },
  _2: {
    title: 'Some hard/sad facts',
    quotes: [
      {
        text: 'Outside Particulate Matter alone is responsible for 467.000 premature deaths in Europe each year.',
        author: 'EEA report ‘Air quality in Europe’',
        year: '2016'
      },
      {
        text: 'The number of premature deaths due to the consequences of air pollution in the EU is more than 10 times the toll of road traffic accidents.',
        author: 'EEA',
        year: '2014'
      },
      {
        text: 'In Belgium alone, every hour at least one person, dies due to air pollution.'
      },
      {
        text: 'Another 6.5 million people in the EU fall sick as air pollution causes diseases such as strokes, asthma and bronchitis.',
        author: 'EEA report',
        year: '2014'
      },
      {
        text: 'Outdoor air pollution was estimated to cause 3 million premature deaths worldwide in 2012.',
        author: 'World Health Organisation'
      },
      {
        text: 'Air pollution is the single largest environmental health risk in Europe.',
        author: 'EEA report ‘Air quality in Europe’',
        year: '2016'
      },
      {
        text: 'In the WHO European Region alone, exposure to particulate matter (PM) decreases the life expectancy of every person by an average of almost 1 year.',
        author: 'WHO Regional Office for Europe'
      },
      {
        text: 'The International Agency for Research on Cancer has classified air pollution as carcinogenic.'
      },
      {
        text: 'Air pollution has been associated with health impacts on fertility, pregnancy, and new-borns and children.',
        author: 'World Health Organisation',
        year: '2013'
      },
      {
        text: 'Air pollution and climate change are intertwined. Several air pollutants are also climate forcers.',
        author: 'EEA report ‘Air quality in Europe’',
        year: '2016'
      },
      {
        text: 'The air quality threshold set by governments (like the EU) are less stringent than these set by the WHO.'
      },
      {
        text: 'In 2014, 92% of the world population was living in places where the WHO air quality guidelines levels were not met.',
        author: 'World Health Organisation'
      },
      {
        text: 'Indoor air pollution also poses considerable impacts on health and is greatly affected by outdoor air pollution.',
        author: 'Royal College of Physicians',
        year: '2016'
      },
      {
        text: 'The European Commission estimated in 2010 to have direct economic damages of 15,8 billion Euros from lost work days and 4 billion Euros from healthcare costs.'
      },
      {
        text: 'The Organisation for Economic Co-operation and Development projects the market costs of air pollution to reach about 2% of European GDP in 2060.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/the-silent-killer_page.js